/** Path of the user change data */

export const UserChangePath = 'user-change';
